import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

class Footer extends React.Component {

  render() {
    const {
      className,
      topOuterDivider,
      topDivider,
      ...props
    } = this.props;

    const classes = classNames(
      'site-footer invert-color',
      topOuterDivider && 'has-top-divider',
      className
    );

    return (
      <footer
        {...props}
        className={classes}
        style={{ background: '#0F172A', paddingTop: '40px', paddingBottom: '40px' }}
      >
        <div className="container">
          <div className={
            classNames(
              'site-footer-inner',
              topDivider && 'has-top-divider'
            )}>
            <div className="footer-top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '32px', marginBottom: '32px' }}>
              <div className="footer-brand">
                <div style={{ fontSize: '20px', fontWeight: '700', color: '#ffffff', marginBottom: '8px' }}>
                  Autonomy Resources
                </div>
                <div style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.6', maxWidth: '280px' }}>
                  Healthcare technology and business consulting for insurance agents, brokers, and modern enterprises.
                </div>
              </div>
              <div className="footer-links" style={{ display: 'flex', gap: '48px', flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
                    Navigation
                  </div>
                  <ul className="list-reset" style={{ margin: 0 }}>
                    <li style={{ marginBottom: '8px' }}>
                      <Link to="/" style={{ color: '#94a3b8', fontSize: '14px', textDecoration: 'none' }}>Home</Link>
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                      <Link to="/#services" style={{ color: '#94a3b8', fontSize: '14px', textDecoration: 'none' }}>Services</Link>
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                      <Link to="/contact/" style={{ color: '#94a3b8', fontSize: '14px', textDecoration: 'none' }}>Contact</Link>
                    </li>
                  </ul>
                </div>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
                    Contact
                  </div>
                  <ul className="list-reset" style={{ margin: 0 }}>
                    <li>
                      <a href="mailto:matt@autonomyresources.online" style={{ color: '#94a3b8', fontSize: '14px', textDecoration: 'none' }}>
                        matt@autonomyresources.online
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-bottom" style={{ borderTop: '1px solid #1e293b', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
              <div style={{ fontSize: '13px', color: '#475569' }}>
                &copy; {new Date().getFullYear()} Autonomy Resources. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
